// import { Navbar } from '../components/Navbar';
// import { Footer } from '../components/Footer';
import { MatrimonyOnboardingWizard } from "@/components/matrimony/M-Edit-Profile-Section";

const MatrimonyOnboardingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50 via-amber-50/70 to-white font-sans text-gray-900">
      <main className="py-10 sm:py-14">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <MatrimonyOnboardingWizard />
        </div>
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default MatrimonyOnboardingPage;
